export default "__VITE_ASSET__BxQG1K5V__"